// extracted by css-extract-rspack-plugin
export default {"codeBlock":"CodeBlock-module__codeBlock___ArJmw","highlight":"CodeBlock-module__highlight___lwXfW"};